<template>
<transition name="Jeu1">
  <div class="Jeu1">

    <div class="Jeu1__cover Vlazy" v-lazy:background-image="oeuvre.image.sizes.large">
      <transition name="Jeu1__hint">
        <div class="Jeu1__hint" v-if="slugIsIn(['writing:1', 'writing:2']) && !reading">{{ trans('hint') }}</div>
      </transition>
      <transition name="Jeu1__infos">
        <div class="Jeu1__infos">
          <div class="Jeu1__infos-title">{{ oeuvre[oeuvre.titre_original].title }}</div>
          <div class="Jeu1__infos-author">{{ oeuvre.author }}</div>
        </div>
      </transition>
    </div>

    <div class="Jeu1__words">
      <transition-group name="Jeu1__word">
        <div class="Jeu1__word" :class="[w.class]" v-for="(w,k) in words" :key="k">{{ w.val }}</div>
      </transition-group>
    </div>

    <transition name="Jeu1__inputs-container">
      <div class="Jeu1__inputs-container" v-if="slugIsIn(['writing:1', 'writing:2']) && words.length < 4">
        <transition name="Jeu1__warning">
          <div v-if="censorship" class="Jeu1__warning">{{ trans('warning') }}</div>
        </transition>
        <input
          ref="word"
          maxlength="22"
          :placeHolder="trans('words')"
          class="Jeu1__input"
          type="text"
          name="word"
          v-model="word"
          @keyup.enter="saveWords()"
          @input="onChange"
          autocomplete="off" />
        <transition name="Jeu1__submit">
          <div v-if="active" class="Btn Jeu1__submit" @mousedown="saveWords()">
            {{ trans('Global.btn.ok') }}
          </div>
        </transition>
      </div>
    </transition>

    <transition name="Jeu1__end">
      <div
        v-if="completed && slugIsIn(['writing:1', 'writing:2'])"
        class="Btn Jeu1__end"
        @click="next" v-html="trans('Global.btn.completed')" />
    </transition>
  </div>
</transition>
</template>

<script>

import TweenMax from 'gsap'
import Filter from 'bad-words'
import { Words } from './js/Words.js'

export default {
  name: 'Jeu1',
  data: () => ({
    completed: false,
    active: false,
    reading: false,
    censorship: false,
    helpers_added: false,
    words: [],
    word: '',
  }),
  beforeDestroy() {
    this.words = []
  },
  watch: {
    '$route': {
      immediate: true,
      handler() {
        if(this.slugIsIn(['writing:1', 'writing:2'])) {
          this.$nextTick(() =>{
            this.$refs.word.focus()
          })
          this.words = []
        }
        if(this.slugIsIn(['4', '4:bis']) && !this.helpers_added)
          this.addHelpers()
      }
    },
  },
  translations: {
    fr: {
      words: "Écrire ici",
      hint: 'Porte attention à ce que tu vois, à ce que tu comprends et à la manière dont c’est fait.',
      warning: 'Si de te moquer tu continues, son appareil photo, plus jamais Nour ne le reverra.'
    },
    en: {
      words: "Write here",
      hint: 'Pay attention to what you see, what you understand, and how it is done.',
      warning: 'If making fun you continue, the camera Nour will never see again.'
    },
  },
  mounted() {
    this.$memory = null
    this.$filter = new Filter()
    this.$filter.addWords(Words)
  },
  methods: {
    enter(el, done) {
      TweenMax.from(el, 1, { alpha: 0, scale: .7, onComplete: done })
    },
    leave(el, done) {
      TweenMax.to(el, 1, { alpha: 0, scale: .7, onComplete: done })
    },
    addHelpers() {
      _.each(this.oeuvre[this.lang].suggestion, (value, index)=> {
        TweenMax.delayedCall(0.15*index, ()=> this.saveWordOnScreen(value.text))
        this.helpers_added = true
      })
    },
    saveWords() {
      if(!this.active) return
      this.saveWordOnScreen(this.word, 'edited')
      this.resetWord()
    },
    resetWord() {
      this.active = false
      this.word = ''
    },
    saveWordOnScreen(value, adds) {
      adds = (adds === undefined) ? '' : adds
      this.words.push({ val: _.capitalize(value), class: adds })
      if(this.words.length > 3)
        this.completed = true
    },
    onChange({ type, target }) {
      this.reading = true
      if(this.$memory) {
        if(this.word.length > this.$memory.length)
          this.word = this.$memory +''+ this.word.charAt(this.word.length-1)
        else
          this.word = this.$memory.slice(0, -1)
        this.$memory = null
      }
      if(this.$filter.isProfane(this.word)) {
        this.$memory = this.word
        this.word = this.$filter.clean(this.word)
        if(this.$tween) this.$tween.kill()
        this.active = false
        this.censorship = true
        return
      }
      this.censorship = false
      if(this.$tween) this.$tween.kill()
      this.$tween = TweenMax.delayedCall(0.25, ()=>{
        this.active = target.value.length > 2
      })
    },
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Jeu1
  position fixed
  top 0px
  left 0px
  right 0px
  bottom 0px
  transition opacity 1s, transform 1s
  &-enter
  &-leave-active
    opacity 0
    transform scale(.7)

  &__infos
    position absolute
    text-align center
    bottom 100%
    margin-bottom 5px
    width 100%
    &-author
      font-size 14px

  &__end
    transition opacity .5s, transform .5s
    &-enter
    &-leave-active
      opacity 0
      transform translateY(20px)

  &__submit
    transition opacity .5s, transform .5s
    position absolute
    bottom inherit
    top 5px
    right 5px
    &-enter
    &-leave-active
      opacity 0
      transform translateX(-20px)

  &__cover
    width 60vw
    left 20vw
    top 110px
    bottom 200px
    position absolute
    background-size contain
    background-position center center
    background-repeat no-repeat

  &__hint
    position absolute
    top 100%
    width 400px
    left 50%
    transform translateX(-50%)
    margin-top 20px
    text-align center
    color white
    transition opacity 1s
    &-enter
    &-leave-active
      opacity 0

  &__words
    position absolute
    left 20px
    top 50%
    transform translateY(-50%)

  &__word
    margin 14px 20px
    color white
    background-color rgba(0, 0, 0, 0.65)
    border-radius 25px
    height 44px
    font-weight 500
    font-size 18px
    line-height 47px
    text-align center
    padding 0 15px
    width 200px
    transition all 0.25s ease-out
    min-width 100px
    &.edited
      color #7c76ff
    &-enter
    &-leave-active
      opacity 0
      transform translateY(50px)

  &__inputs-container
    position absolute
    bottom 25px
    left 50%
    transform translateX(-50%)
    transition opacity 1s, transform 1s
    &-enter
    &-leave-active
      opacity 0
      transform translate(-50%, 100px)

  &__input
    font-size 22px
    border none
    color white
    width 420px
    height 54px
    background-color rgba
    border-radius 32px
    padding 0 22px
    &::placeholder
      color rgba(white, .5)
      opacity 1

  &__warning
    position absolute
    top -90px
    text-align center
    transition opacity 1s
    &-enter
    &-leave-active
      opacity 0

</style>



// WEBPACK FOOTER //
// src/components/jeu1/Jeu1.vue